var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "component-form" },
    [
      _c("h1", { staticClass: "form-title" }, [_vm._v("Video Introduction")]),
      _c("p", { staticClass: "text mt-30" }, [
        _vm._v(
          " Please submit a 30 second video introducing yourself and the topic you’ll be teaching. This can be something very simple filmed on your phone/computer camera — the students are really excited to see you guys! "
        )
      ]),
      _c("FileUploader", {
        staticClass: "mt-20 inp-wrap big",
        attrs: {
          text: "Upload Video",
          acceptType: ["MP4", "AVI", "MOV"],
          value: _vm.value.video,
          loadText: "loading",
          msg: "Less than 500 MB",
          showMsg: "",
          maxSize: 500,
          role: _vm.ROLES.SL
        },
        on: {
          input: function($event) {
            return _vm.handleInput($event, "video")
          }
        }
      }),
      _c(
        "Button",
        {
          staticClass: "btn-submit mt-50",
          on: { click: _vm.handleClickSubmit }
        },
        [_vm._v("Submit")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }